export default {
  "content": "<path d=\"M21.207 7.293a1 1 0 010 1.414l-4.5 4.5-1.414-1.414L18.086 9H9.5a4.5 4.5 0 100 9H13v2H9.5a6.5 6.5 0 010-13h8.586l-2.793-2.793 1.414-1.414 4.5 4.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};